import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { LocalizationSchemas } from "../ea.schema";
import { GetRequestBaseResponseSchema, LocalizatonFilterSchema } from "../ea.schema.query";
import { BooleanSchema } from "../ea.schema.helpers";

const base = "localizations";
const loc = createEndpointBase(base);

export const localizationsEndpoints = {
  localizationsGet: loc({
    method: "GET",
    path: "",
    request: z.object({ filter: LocalizatonFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(LocalizationSchemas["general"]),
    description: "Retrieves a list of localizations with filtering support.",
  }),
  localizationsGetOne: loc({
    method: "GET",
    path: ":locale",
    request: z.object({ locale: z.string(), objectFormat: BooleanSchema.optional() }),
    response: LocalizationSchemas["general"],
    description: "Retrieves a single localization by locale.",
  }),
  localizationsCreate: loc({
    method: "POST",
    path: "",
    request: z.any(),
    response: z.any(),
    description: "Creates a new localization entry.",
  }),
  localizationsUpdate: loc({
    method: "PATCH",
    path: ":id",
    request: z.any(),
    response: z.any(),
    description: "Updates an existing localization entry.",
  }),
  localizationsDelete: loc({
    method: "DELETE",
    path: ":id",
    request: z.object({ id: z.number() }),
    response: z.any(),
    description: "Deletes a localization entry.",
  }),
  localizationsCount: loc({
    method: "GET",
    path: "count",
    request: z.any(),
    response: z.any(),
    description: "Returns the total number of localizations matching the filters.",
  }),
  localizationsExport: loc({
    method: "POST",
    path: "export/:id",
    request: z.any(),
    response: z.any(),
    description: "Exports localization data to a JSON file.",
  }),
  localizationsImport: loc({
    method: "POST",
    path: "import",
    request: LocalizationSchemas.import,
    response: z.any(),
    description: "Imports localization data from a JSON file.",
  }),
  localizationsTranslations: loc({
    method: "GET",
    path: "translation",
    request: z.object({ locale: z.string(), objectFormat: BooleanSchema.optional() }),
    response: z.any(),
    description: "Retrieves translations for a specific locale and format.",
  }),
} as const;
